const TRUNCATED_DESCRIPTION_MAX_LENGTH = 250;
const DESCRIPTION_LENGTH_THRESHOLD = 300;

export { TRUNCATED_DESCRIPTION_MAX_LENGTH, DESCRIPTION_LENGTH_THRESHOLD };
